/*
 * SkillDetailModal Messages
 *
 * This contains all the text for the SkillDetailModal component.
 */
import { defineMessages } from 'react-intl';

export const buttons = defineMessages({
  submit: {
    id: 'graphql.SkillDetailModal.buttons.submit',
    defaultMessage: 'Save',
  },
  delete: {
    id: 'graphql.SkillDetailModal.buttons.delete',
    defaultMessage: 'Delete',
  },
  submitValidation: {
    id: 'graphql.SkillDetailModal.buttons.submitValidation',
    defaultMessage: 'Submit {level} level validation',
  },
  removeHighlighted: {
    id: 'graphql.SkillDetailModal.buttons.removeHighlighted',
    defaultMessage: 'Remove from Highlighted Skills Section',
  },
  addHighlighted: {
    id: 'graphql.SkillDetailModal.buttons.addHighlighted',
    defaultMessage: 'Add to Highlighted Skills Section',
  },
  submitClaim: {
    id: 'graphql.SkillDetailModal.buttons.submitClaim',
    defaultMessage: 'Submit new claim',
  },
  takeChatbot: {
    id: 'graphql.SkillDetailModal.buttons.takeChatbot',
    defaultMessage: 'Take Chatbot',
  },
});

export const status = defineMessages({
  validated: {
    id: 'graphql.SkillDetailModal.status.validated',
    defaultMessage: 'VALIDATED',
  },
  unvalidated: {
    id: 'graphql.SkillDetailModal.status.unvalidated',
    defaultMessage: 'UNVALIDATED',
  },
  title: {
    id: 'graphql.SkillDetailModal.status.title',
    defaultMessage: 'STATUS',
  },
});

export const tableHeaders = defineMessages({
  skills: {
    id: 'graphql.SkillDetailModal.tableHeaders.skills',
    defaultMessage: 'SKILLS',
  },
  category: {
    id: 'graphql.SkillDetailModal.tableHeaders.category',
    defaultMessage: 'CATEGORY',
  },
  level: {
    id: 'graphql.SkillDetailModal.tableHeaders.level',
    defaultMessage: 'LEVEL',
  },
  status: {
    id: 'graphql.SkillDetailModal.tableHeaders.status',
    defaultMessage: 'STATUS',
  },
  validationType: {
    id: 'graphql.SkillDetailModal.tableHeaders.validationType',
    defaultMessage: 'VALIDATION TYPE',
  },
});

export const levels = defineMessages({
  beginner: {
    id: 'graphql.SkillDetailModal.levels.beginner',
    defaultMessage: 'Beginner',
  },
  intermediate: {
    id: 'graphql.SkillDetailModal.levels.intermediate',
    defaultMessage: 'Intermediate',
  },
  expert: {
    id: 'graphql.SkillDetailModal.levels.expert',
    defaultMessage: 'Expert',
  },
});

export const validationTypes = defineMessages({
  claim: {
    id: 'graphql.SkillDetailModal.validationTypes.claim',
    defaultMessage: 'Claim',
  },
  chatbot: {
    id: 'graphql.SkillDetailModal.validationTypes.chatbot',
    defaultMessage: 'Chatbot',
  },
});

export const lastValidation = defineMessages({
  claim: {
    id: 'graphql.SkillDetailModal.lastValidation.claim',
    defaultMessage: 'Last validation on {timestamp}',
  },
  chatbot: {
    id: 'graphql.SkillDetailModal.lastValidation.chatbot',
    defaultMessage: 'Last validation on {timestamp}',
  },
});
